import { type RootState } from 'src/store';
import { useSelector } from 'react-redux';
import { userTypes } from 'src/helpers';
import Admin from './Admin';
import Institution from './Institution';

function Home() {
	const user = useSelector((state: RootState) => state.auth.data);

	function getContent() {
		if (user.type === userTypes.ADMIN) {
			return <Admin />;
		}

		return <Institution />;
	}

	return getContent();
}

export default Home;
